module.exports = __webpack_public_path__ + "static/gale-mtg_cls-e14497d9fe8994b71fb2974a8d1623f0.jpg";